$('.questions-t .qt[data-type=7]').each(function (i, q) {
	let $words = $(q).find('.words .word');

	$words.on('dragstart', function () {
		$(this).addClass('moving');
	}).on('dragend', function (e) {
		$(this).removeClass('moving');
	}).on('touchstart', function (e) {
		$(this).addClass('moving');
	}).on('touchend', function (e) {
		let x = e.originalEvent.changedTouches[0].clientX;
		let y = e.originalEvent.changedTouches[0].clientY;

		let elemFromPoint = document.elementFromPoint(x, y);
		let $elemFromPoint = $(elemFromPoint);
		if ($elemFromPoint.hasClass('answer-items-holder')) {
			$elemFromPoint.trigger('drop');
		}

		$(this).removeClass('moving');
	}).on('touchmove', function (e) {
		let xPage = e.originalEvent.changedTouches[0].pageX;
		let yPage = e.originalEvent.changedTouches[0].pageY;
		let xClient = e.originalEvent.changedTouches[0].clientX;
		let yClient = e.originalEvent.changedTouches[0].clientY;

		$(this).css({
			'left': xPage + 20,
			'top': yPage - 300,
		});

		hwScrollLock(xClient, yClient);

		let elemFromPoint = document.elementFromPoint(xClient, yClient);
		let $elemFromPoint = $(elemFromPoint);

		if ($elemFromPoint.hasClass('answer-items-holder')) {
			$elemFromPoint.addClass('dragover');
		}

		$(q).find('.answer-items-holder')
			.not($elemFromPoint).removeClass('dragover');

		return false;
	});

	$(q).find('.answer-items-holder').on('dragover', function (e) {
		$(this).addClass('dragover');
		e.preventDefault();
	}).on('dragleave', function (e) {
		$(this).removeClass('dragover');
	}).on('drop', function (e) {
		$(this).removeClass('dragover').addClass('has-items');

		let $activeElement = $words.filter('.moving');
		let $target = $(e.delegateTarget);

		let qId = $(q).data('id');
		let gId = $(this).closest('[data-col]').data('col');
		let word = $activeElement.data('word');
		let index = $activeElement.data('index');
		let inputName = "q["+qId+"][groups]["+gId+"][words][]";

		let html = '<div class="item">' +
			$('<input />').attr('type', 'hidden').attr('name', inputName).attr('value', word)[0].outerHTML +
			'<span class="word">'+word+'</span>' +
			'<a href="#" class="btn-del" data-index="'+index+'"><i class="fa fa-times"></i></a>' +
			'</div>';

		$(this).append(html);
		$activeElement.hide();

		Lection.cacheHomework();
	});

	$(q).on('click', '.item .btn-del', function () {
		let $item = $(this).closest('.item');
		let index = $(this).data('index');
		let $answersHolder = $(this).closest('.answer-items-holder')

		$item.remove();

		$(q).find('.words .word[data-index="'+index+'"]').show();

		let countWords = $answersHolder.find('.item').length;
		if (!countWords) {
			$answersHolder.removeClass('has-items');
		}

		Lection.cacheHomework();

		return false;
	});
});